import { render, staticRenderFns } from "./AdvDetail.vue?vue&type=template&id=7f1dc608&scoped=true"
import script from "./AdvDetail.vue?vue&type=script&lang=js"
export * from "./AdvDetail.vue?vue&type=script&lang=js"
import style0 from "./AdvDetail.vue?vue&type=style&index=0&id=7f1dc608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1dc608",
  null
  
)

export default component.exports